export const version = "bytes/5.1.0";
//# sourceMappingURL=_version.js.map